
import { defineComponent } from "vue";

import { OrganizeActivitiy } from "@/api/organizeActivitiyApi";

import runEvn from "@/modular/runEvn/RunEvn";
const { fileBaseUrl } = runEvn();

export default defineComponent({
    data() {
        return {
            formData: {
                name: "",
                pageNum: 1,
                pageSize: 10,
            },
        };
    },

    methods: {
        img(key: string) {
            return fileBaseUrl + key.split(",")[0];
        },

        async loadOrganizeActivitiy({ index, setData }) {
            const params = {
                ...this.formData,
            };
            const response = (await OrganizeActivitiy(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
        },

        refreshData() {
            this.$refs.appListRef.onRefresh();
        },

        goToActivityDescription(item: { id: string }) {
            this.$router.push({
                path: "/volunteerActive/activityDescription",
                query: { id: item.id },
            });
        },

        formatData() {
            /**
             * startTime 开始时间
             * endTime 结束时间
             * type 类型 1：已发布，2：进行中，3：结束活动
             */
            const formatActivityDay = (
                startTime: number,
                endTime: number,
                type: number
            ) => {
                let data = (endTime - startTime) / 1000;
                if (data == undefined) return "";

                if (type == 1) {
                    return "即将开始";
                }

                if (type == 3) {
                    return "活动结束";
                }

                if (typeof data == "string") {
                    data = Number(data);
                }

                // 先把天数换算出来
                data = data / 3600 / 24;

                const hourArr: Array<any> = data.toString().split(".");

                if (hourArr[0] > 0 && hourArr[0] > 0) {
                    hourArr[0] = hourArr[0] + "天";

                    if (hourArr[0] > 99) {
                        hourArr[0] = hourArr[0] + "天+";
                    }
                } else {
                    hourArr[0] = "";
                }

                if (hourArr[1]) {
                    hourArr[1] = "." + hourArr[1];
                    // 将后面的小数转换回时间
                    hourArr[1] = parseInt(String(Number(hourArr[1]) * 24));

                    if (hourArr[1] <= 0) hourArr[1] = "";
                    else hourArr[1] = hourArr + "小时";
                } else {
                    // 如果没有小数点，后面这个就传空字符串
                    hourArr[1] = "";
                }

                console.log("hourArr :>> ", hourArr);

                return hourArr[0] + hourArr[1];
            };

            return { formatActivityDay };
        },
    },
});
